var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", [
    _c("div", { staticClass: "container pt-2 pl-3 pb-2 pr-3" }, [
      _c("div", { staticClass: "d-block d-sm-none" }, [
        _c("div", { staticClass: "row" }, [_c("stea-link")], 1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row mt-3" },
          [!_vm.isInPrintMode ? _c("privacy-policy-link") : _vm._e()],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row mt-3" },
          [!_vm.isInPrintMode ? _c("accessibility-statement-link") : _vm._e()],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row mt-3" },
          [!_vm.isInPrintMode ? _c("qa-link") : _vm._e()],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row mt-3" },
          [!_vm.isInPrintMode ? _c("support-link") : _vm._e()],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-none d-sm-block d-lg-none" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-9" }, [
            _c("div", { staticClass: "row" }, [_c("stea-link")], 1),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row mt-3" },
              [!_vm.isInPrintMode ? _c("privacy-policy-link") : _vm._e()],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row" },
              [
                !_vm.isInPrintMode
                  ? _c("accessibility-statement-link")
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [_c("qa-link")], 1)
          ]),
          _vm._v(" "),
          !_vm.isInPrintMode
            ? _c(
                "div",
                { staticClass: "col-3" },
                [_c("support-link", { staticClass: "float-right" })],
                1
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-none d-lg-block" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-2" }, [_c("stea-link")], 1),
          _vm._v(" "),
          !_vm.isInPrintMode
            ? _c(
                "div",
                { staticClass: "col-2 text-center text-nowrap" },
                [_c("privacy-policy-link")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isInPrintMode
            ? _c(
                "div",
                { staticClass: "col-3 text-center text-nowrap" },
                [_c("accessibility-statement-link")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isInPrintMode
            ? _c(
                "div",
                { staticClass: "col-2 text-center text-nowrap" },
                [_c("qa-link")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isInPrintMode
            ? _c("div", { staticClass: "col-3 right" }, [_c("support-link")], 1)
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }